import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleTemplate from '@/pages/article/components/ArticleTemplate';
import { pricingArticle } from '@/mocks/articleData';

export default function PricingArticle() {
  return (
    <>
      <Navbar />
      <ArticleTemplate article={pricingArticle} />
      <Footer />
    </>
  );
}